module.exports = __webpack_public_path__ + "img/文化日.4d2bd6d1.jpg";